import React from 'react'

interface IGraficoSelfProps {
  fatorA: number
  fatorB: number
  fatorC: number
  fatorD: number
}

export const GraficoSelf: React.FC<IGraficoSelfProps> = ({ fatorA, fatorB, fatorC, fatorD }) => {
  const norma = 238
  const amplitudeGrafico = 79

  // Converter os valores (-3 a 3) para posições no SVG
  const fatorAx = norma + fatorA * amplitudeGrafico
  const fatorBx = norma + fatorB * amplitudeGrafico
  const fatorCx = norma + fatorC * amplitudeGrafico
  const fatorDx = norma + fatorD * amplitudeGrafico

  return (
    <svg width="478" height="106" viewBox="0 0 478 106" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_2)">
        <path d="M476.92 0.5H0.5V101.27H476.92V0.5Z" fill="white" />
        <path d="M476.42 1V100.77H1V1H476.42ZM477.42 0H0V100.77H477.42V0Z" fill="#C9CBCC" />
        <path d="M238.71 91.77L246.71 105.77H230.71L238.71 91.77Z" fill="black" />
        <path d="M477.42 99.77H0V105.77H477.42V99.77Z" fill="#3189C0" />
        <path d="M238.71 381.14V84.616" stroke="#C9CBCC" strokeWidth="0.617401" strokeMiterlimit={10} />

        {/* Círculos */}
        <circle cx={fatorAx} cy={21.154} r={6.49} fill="#000000" />
        <circle cx={fatorBx} cy={42.308} r={6.49} fill="#000000" />
        <circle cx={fatorCx} cy={63.462} r={6.49} fill="#000000" />
        <circle cx={fatorDx} cy={84.616} r={6.49} fill="#000000" />

        {/* Linhas conectando os círculos */}
        <line x1={fatorAx} y1={21.154} x2={fatorBx} y2={42.308} stroke="#252525" strokeWidth="2" strokeMiterlimit={10} />
        <line x1={fatorBx} y1={42.308} x2={fatorCx} y2={63.462} stroke="#252525" strokeWidth="2" strokeMiterlimit={10} />
        <line x1={fatorCx} y1={63.462} x2={fatorDx} y2={84.616} stroke="#252525" strokeWidth="2" strokeMiterlimit={10} />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect width="477.42" height="105.77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GraficoSelf
